export default (state = [], action) => {
  switch (action.type) {
    case "CREATE_CONTACT":
      return [...state, action.payload.contact];
    case "UPDATE_CONTACTS":
      return action.payload.contacts;
    case "DELETE_CONTACT":
      return state.filter((contact) => {
        return contact.id !== action.payload.contact.id
      });
    default:
      return state;
  }
}
